import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoginPage } from '../../../auth/login/login';

/**
 * Generated class for the ConfigurationEstablishmentDeletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-establishment-delete',
  templateUrl: 'configuration-establishment-delete.html',
})
export class ConfigurationEstablishmentDeletePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public afAuth: AngularFireAuth,
    public toastCtrl: ToastController) {
  }

  cancel() {
    this.navCtrl.pop();
  }

  delete() {
    //enviar a CF(cloud functions)
    this.configurationServices.afs.collection('_functions').add({
      'uid': this.globals.restaurant_uid, //uid restaurante
      'uid_user': this.globals.user_uid, //uid usuario
      'uid_user_auth': this.globals.user_uid_auth, //uid usuario autenticado
      'date': moment(new Date()).format('YYYY-MM-DD HH:mm:ss'), //fecha 
      'type': 'account_delete', //tipo de informacion en _data (switchcase)
    }).then(() => {
      //informar al usuario y cerrarle session
      const alert = this.alertCtrl.create({
        title: this.translate.instant('general-restaurante-eliminado-correctamente'),
        message: this.translate.instant('general-se-eliminaran-datos-generados-en-24horas'),
        buttons: [{
          text: this.translate.instant('general-cerrar'),
          handler: () => {
            this.delNotTokenAndLogout();
            this.globals.open_side_menu = false;
          }
        }]
      });
      alert.present();
    });

  }



  async delNotTokenAndLogout() {
    //funcion que borra token
    await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
    //hacemos logout de afAuth
    this.afAuth.auth.signOut()
      .then(authData => {
        // toast message
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-cerrado-sesion'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        //
        if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
          this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
        }
        //
        this.navCtrl.setRoot(LoginPage);
        window.location.reload();
      }, error => {
        //var errorMessage: string = error.message;
      });
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-establishment/configuration-establishment-delete/configuration-establishment-delete.ts